<div class="practice-city-card">
    <!-- Card Header -->
  <div class="card-header">
    <div class="header-left">
      <div class="title-row">
        <h2 class="city-name">{{ practiceCity.city }}</h2>
        <button mat-icon-button
          class="responsibles-toggle"
          [matTooltip]="'Felelősök: ' + (responsibles || 'Nincs megadva')"
          matTooltipPosition="below"
          (click)="isUserAuthorizedForChange ? handleEditResponsiblesIconClick() : null"
          [style.cursor]="isUserAuthorizedForChange ? 'pointer' : 'default'">
          <mat-icon>{{ responsibles ? 'people' : 'person_add' }}</mat-icon>
        </button>
      </div>
      <div class="status-badges">
        <span class="status-badge" [ngClass]="'status-' + (practiceCity.status || 'TODO').toLowerCase().replace('_', '-')">
          {{
            {
              'IN_PROGRESS': 'Folyamatban',
              'DONE': 'Kész',
              'TODO': 'TODO'
            }[practiceCity.status] || practiceCity.status || 'TODO'
          }}
        </span>
        <span *ngIf="!practiceCity.isVisible" class="visibility-badge">
          <mat-icon>visibility_off</mat-icon>
          <span>Rejtett</span>
        </span>
      </div>
    </div>

    <div class="header-actions">
      <button mat-icon-button
        matTooltip="Statisztika"
        (click)="handleShowStatisticsButtonClick()">
        <mat-icon>assessment</mat-icon>
      </button>

      <button mat-icon-button
        matTooltip="UUID: {{ practiceCity.uuid }}"
        (click)="handleInfoButtonClick()">
        <mat-icon>info_outline</mat-icon>
      </button>

      <div class="action-separator"></div>

      <button mat-icon-button
        matTooltip="Vizsgahelyszín módosítása"
        *ngIf="isUserAuthorizedForChange"
        [disabled]="!isAdminContentResponsible()"
        (click)="handleEditButtonClick()">
        <mat-icon>edit</mat-icon>
      </button>

      <button mat-icon-button
        *ngIf="isUserAuthorizedForChange"
        matTooltip="Törlés"
        [disabled]="!isAdminContentResponsible()"
        (click)="handleDeleteButtonClick()"
        class="delete-button">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <!-- Statistics Grid -->
  <div class="statistics-grid">
    <div class="stat-card">
      <mat-icon>description</mat-icon>
      <div class="stat-content">
        <span class="stat-value">{{ practiceCity.countOfExamPath }}</span>
        <span class="stat-label">vizsgatétel</span>
      </div>
    </div>

    <div class="stat-card">
      <mat-icon>location_on</mat-icon>
      <div class="stat-content">
        <span class="stat-value">{{ practiceCity.nodes.length }}</span>
        <span class="stat-label">érintési pont</span>
      </div>
    </div>

    <div class="stat-card">
      <mat-icon>warning</mat-icon>
      <div class="stat-content">
        <span class="stat-value">{{ practiceCity.criticalPoints.length }}</span>
        <span class="stat-label">kritikus pont</span>
      </div>
    </div>

    <div class="stat-card">
      <mat-icon>videocam</mat-icon>
      <div class="stat-content">
        <span class="stat-value">{{ practiceCity.practicePathUuids.length }}</span>
        <span class="stat-label">videó</span>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button mat-stroked-button
      matTooltip="Vizsga érintési pontok sorrendje a vizsgaútvonalakban"
      *ngIf="isUserAuthorizedForChange"
      [disabled]="!isAdminContentResponsible()"
      (click)="openExamNumberNodeAssignmentEditorDialog()">
      <mat-icon>edit_road</mat-icon>
      <span>Sorrend szerkesztése</span>
    </button>

    <button mat-stroked-button
      matTooltip="Zónák"
      [disabled]="!isAdminContentResponsible()"
      (click)="handleZoneButtonClick()">
      <mat-icon>layers</mat-icon>
      <span>Zónák</span>
    </button>

    <button mat-stroked-button
      matTooltip="Vizsga érintési pontok"
      [disabled]="!isAdminContentResponsible()"
      (click)="handleEditNodesButtonClick()">
      <mat-icon>hub</mat-icon>
      <span>Érintési pontok</span>
    </button>

    <button mat-raised-button
      color="primary"
      [routerLink]="[practiceCity.uuid, 'paths']"
      [disabled]="!isAdminContentResponsible()"
      class="primary-action">
      <mat-icon>route</mat-icon>
      <span>Útvonalak</span>
    </button>
  </div>
</div>
